import { Icon } from "@/shared/ui";

type Props = {
  address: string;
};
export default function OfferEstateLocation({ address }: Props) {
  return (
    <div className="flex items-center gap-2.5 my-4 px-1 text-inverted">
      <Icon category="home-menu" name="location" className="w-5" />
      <div className="text-16 font-medium">{address}</div>
    </div>
  );
}
